import type { InviteResponse } from '@escala/contracts';
import type { MemberAccess, StoredRole } from '@escala/domain/types';

import type { Api } from '@/services/api/escala';
import { changePassword, endOtherSessions, requestPasswordReset } from '@/services/api/session';

/**
 * Acessos dos membros (tela Acessos e aba Acesso do perfil). Com a API, cada operação é
 * uma rota de `/accesses` (nos testes, `test/memory`).
 */
export interface AccountsClient {
  list: () => Promise<MemberAccess[]>;
  get: (memberId: string) => Promise<MemberAccess>;
  invite: (memberIds: string[]) => Promise<InviteResponse>;
  /** Administrador ou não; os perfis de líder vêm das lideranças. */
  changeRole: (memberId: string, role: StoredRole) => Promise<MemberAccess>;
  revoke: (memberId: string) => Promise<MemberAccess>;
  endSessions: (memberId: string) => Promise<void>;
  /** A própria senha (confere a atual) e as próprias sessões. */
  changePassword: (current: string, next: string) => Promise<void>;
  /** "Esqueci a senha atual": o link de redefinição para o e-mail do login, na igreja aberta. */
  requestPasswordReset: (email: string, org: string) => Promise<void>;
  endOtherSessions: () => Promise<void>;
}

export function apiAccounts(api: Api): AccountsClient {
  return {
    list: api.accesses,
    get: api.access,
    invite: api.invite,
    changeRole: api.changeAccessRole,
    revoke: api.revokeAccess,
    endSessions: async (memberId) => {
      await api.endMemberSessions(memberId);
    },
    changePassword: async (current, next) => {
      await changePassword(current, next);
    },
    endOtherSessions: async () => {
      await endOtherSessions();
    },
    requestPasswordReset: async (email, org) => {
      await requestPasswordReset(email, org);
    },
  };
}
